/**
 * @generated SignedSource<<d2ee4daf92eb367bbc5c2c6351241f35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PullRequestRowSecondary$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckRunStatusFromPullRequest" | "IssuePullRequestStateIconSecondary" | "ReviewDecision">;
  readonly " $fragmentType": "PullRequestRowSecondary";
};
export type PullRequestRowSecondary$key = {
  readonly " $data"?: PullRequestRowSecondary$data;
  readonly " $fragmentSpreads": FragmentRefs<"PullRequestRowSecondary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PullRequestRowSecondary",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssuePullRequestStateIconSecondary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReviewDecision"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckRunStatusFromPullRequest"
    }
  ],
  "type": "PullRequest",
  "abstractKey": null
};

(node as any).hash = "7c5bae3057e123c5586a02174e11a833";

export default node;
